import React from "react";
//@ts-ignore
import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { Link } from "react-router-dom";

export interface MenuProps {
  onClick: () => void;
  label: string;
  actived: boolean;
  isLink?: boolean;
  link?: string;
}

interface Props {
  items: MenuProps[];
  menuButton: any;
}

export function MenuComponent(props: Props) {
  return (
    <Menu
      menuButton={props.menuButton}
      position={"auto"}
      direction="left"
      arrow={true}
      style={{
        zIndex: 1000,
      }}
    >
      {props.items
        .filter((x) => x.actived)
        .map((x, i) => {
          return (
            <MenuItem key={i} onClick={x.onClick}>
              {x.isLink ? (
                <Link to={x.link!} style={{ textDecoration: "none", color: "#212529" }}>
                  <small>{x.label}</small>
                </Link>
              ) : (
                <small>{x.label}</small>
              )}
            </MenuItem>
          );
        })}
    </Menu>
  );
}
